import actionCreatorFactory from 'typescript-fsa';
const actionCreator = actionCreatorFactory();

export interface IManageOrg {
	org_id: string;
	label: string;
}
export interface IHtmlFile {
	fileName: string;
	filePath: string;
	htmlUrl: string;
	resourceFolder: string;
}

export interface ITestFileInfo {
	fileName: string;
	file: File | null;
}

export interface IFileInfo {
	key: string;
	htmlFile: IHtmlFile;
	name: string;
	type: string;
	size: string;
}

export interface ICurrentItem {
	kind: string;
	page: number;
}

export interface IAnswer {
	answerText: string;
	answer: boolean;
	value: string;
}

export interface IQuestionInfo {
	seq: number;
	questionKind: string;
	questionText: string;
	options: IAnswer[];
	questionScore: number;
	explanation: string;
}

export interface ITestInfo {
	isOneQuestionOneAnswer: boolean;
	passScore: number;
	numberOfQuestions: number;
	questions: IQuestionInfo[];
	unAnswering: boolean;
}

export const setCourseFolder = actionCreator<{
	courseFolder: string;
	fileSize: string;
}>('SET_COURSE_FOLDER');

export const setText = actionCreator<{
	files: IFileInfo[];
}>('SET_TEXT');

export const setViewItem = actionCreator<{
	viewItem: string[];
}>('SET_VIEW_ITEM');

export const setCurrentItem = actionCreator<{
	kind: string;
	page: number;
}>('SET_CURRENT_ITEM');

export const setTestFile = actionCreator<{
	file: File | null;
	fileName: string;
}>('SET_TEST_FILE');

export const setTestData = actionCreator<{
	templateData: ITestInfo | null;
}>('SET_TEST_DATA');

export const setCourseName = actionCreator<{
	courseName: string;
}>('SET_COURSE_NAME');

export const setManageOrg = actionCreator<{
	manageOrgList: IManageOrg[];
}>('SET_MANAGEORG');

export const setOrgId = actionCreator<{
	orgId: string;
}>('SET_ORG_ID');

export const setIndexTree = actionCreator<{}>('SET_INDEX_TREE');

export const reSetCurrentItem = actionCreator<{}>('RESET_CURRENT_ITEM');



// WEBPACK FOOTER //
// ./src/actions/quickModeContens.ts